<div class="modal-roles flex flex-col justify-between h-full">
	<div class="modalHeader">
		<div class="flex">
			<div class="titleNewModule">
				<span>Add Fields </span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
		<div class="contentTabs mb-4"></div>
	</div>
	<div mat-dialog-content class="modalContent mt-4 h-full">
		<form class="" [formGroup]="formFields">
			<div class="contentGeneral flex flex-col">
				<div class="pr-4 flex w-full">
					<div class="form-group mr-4">
						<label for="">HTML Type <span class="asteriks">*</span></label>
						<p-dropdown
							[options]="types"
							[(ngModel)]="selectedTypes"
							placeholder="Select a City"
							optionLabel="name"
							[showClear]="true"
						></p-dropdown>
					</div>
					<div class="w-full pb-4 flex ml-4 flex-row">
						<div class="flex items-center mr-12">
							<input type="checkbox" name="" id="" />
							<label class="ml-4" for="">Encrypted</label>
						</div>
						<div class="flex items-center">
							<input type="checkbox" name="" id="" />
							<label class="ml-4" for="">Required</label>
						</div>
					</div>
				</div>
				<div class="pr-4 flex w-full">
					<div class="form-group mr-4">
						<label for="">Name <span class="asteriks">*</span></label>
						<input type="text" placeholder="Type the name of the field" formControlName="name" />
					</div>
					<div class="form-group ml-4">
						<label for="">Label <span class="asteriks">*</span></label>
						<input type="text" placeholder="Type the title of the field" formControlName="label" />
					</div>
				</div>
				<div class="pr-4 flex w-full">
					<div class="form-group mr-4">
						<label for="">Placeholder <span class="asteriks">*</span></label>
						<input
							type="text"
							placeholder="Type the description of the field"
							formControlName="placeholder"
						/>
					</div>
					<div class="form-group ml-4">
						<label for="">Help text</label>
						<input
							type="text"
							placeholder="Type the help text of the field"
							formControlName="helpText"
						/>
					</div>
				</div>
				<div class="pr-4 flex w-2/4">
					<div class="form-group mr-2">
						<label for="">Help URL </label>
						<input
							type="text"
							placeholder="Add the help URL of the field"
							formControlName="helpUrl"
						/>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div mat-dialog-actions class="footer-modal modalAction flex justify-end">
		<div class="px-2">
			<button class="secundaryButton" (click)="onNoClick()">Cancel</button>
		</div>
		<div class="px-2">
			<button class="primaryButton" [disabled]="formFields.invalid">Save</button>
		</div>
	</div>
</div>
